export default __webpack_public_path__ + "static/media/calendar_active.4dcaaf71.svg";